import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getContactTypes } from 'modules/settings/api';

export const useQueryContactTypes = () =>
  useQuery(QUERY_KEYS.SETTINGS_PROFILE_CONTACT_TYPES, getContactTypes, {
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  });
